
import { useState, useEffect } from "react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      onClick={handleClick}
      aria-label="Scroll to top"
      className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 w-12 h-12 flex items-center justify-center rounded-full bg-sky-500 text-white shadow-lg hover:bg-sky-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
      style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}
